import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen pt-12 pb-20 px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-slate-600 hover:text-navy mb-8 transition-colors"
        >
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        
        <h1 className="font-serif text-4xl md:text-5xl font-bold text-navy mb-6">
          Terms of Use
        </h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 text-lg mb-8">
            Last updated: February 2026
          </p>
          
          <div className="space-y-6 text-slate-600">
            <section>
              <h2 className="font-serif text-2xl font-bold text-navy mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Third Culture Leadership website, you accept and agree to be bound by these Terms of Use.
              </p>
            </section>
            
            <section>
              <h2 className="font-serif text-2xl font-bold text-navy mb-3">2. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, and images, is the property of Third Culture Leadership and Promise Monday, and is protected by copyright laws.
              </p>
            </section>
            
            <section>
              <h2 className="font-serif text-2xl font-bold text-navy mb-3">3. Use of Content</h2>
              <p>
                You may view, download, and print content from this website for personal, non-commercial use only. Any reproduction, distribution, or commercial use of our content without prior written permission is strictly prohibited.
              </p>
            </section>
            
            <section>
              <h2 className="font-serif text-2xl font-bold text-navy mb-3">4. Course & Assessment Terms</h2>
              <p>
                Access to our courses and the CFQ™ Assessment is provided for personal development purposes. The content is not intended as clinical or psychological assessment and should not be used as a substitute for professional advice. Results from the CFQ™ Assessment are for reflective purposes only.
              </p>
            </section>
            
            <section>
              <h2 className="font-serif text-2xl font-bold text-navy mb-3">5. Contact</h2>
              <p>
                For questions about these Terms, please contact us at contact@thirdcultureleadership.co.uk.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
